import React from "react";
import { Layout } from "../../components/layout";
import { LayoutTemplate } from "lucide-react";

export function TemplatesDocsPage() {
  return (
    <Layout fullWidth>
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-8">
          <LayoutTemplate className="h-8 w-8 text-yellow-400" />
          <h1 className="text-3xl font-bold text-white">Templates</h1>
        </div>

        <div className="prose prose-invert max-w-none">
          <div className="space-y-8">
            <section>
              <h2>Using Templates</h2>
              <p>
                Templates provide a quick starting point for creating common
                block patterns. Learn how to effectively use and customize our
                pre-built templates.
              </p>
              <div className="bg-gray-800/50 rounded-lg p-4 mt-4">
                <h3 className="text-lg font-semibold mb-2">
                  Available Template Categories
                </h3>
                <ul className="list-disc list-inside">
                  <li>Headers</li>
                  <li>Hero Sections</li>
                  <li>Features</li>
                  <li>Pricing Tables</li>
                  <li>Call to Action</li>
                  <li>Testimonials</li>
                </ul>
              </div>
            </section>

            <section>
              <h2>Customization Options</h2>
              <p>
                Every template can be customized to match your brand and
                requirements:
              </p>
              <ul>
                <li>Colors and Typography</li>
                <li>Layout and Spacing</li>
                <li>Content and Media</li>
                <li>Responsive Behavior</li>
              </ul>
            </section>

            <section>
              <h2>Creating Templates</h2>
              <p>
                Learn how to create and save your own templates for future use:
              </p>
              <ol>
                <li>Design your pattern using the generator</li>
                <li>Save to your template library</li>
                <li>Add metadata and categories</li>
                <li>Share with your team (Pro feature)</li>
              </ol>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
